// import React from "react";

// const ServiceArea = () => {
//   return (
//     <>
//       {/* Breadcrumb */}
//       <section className="gauto-breadcromb-area section_70">
//         <div className="container">
//           <div className="row">
//             <div className="col-md-12">
//               <div className="breadcromb-box">
//                 <h3>Our Services</h3>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Services Section */}
//       <section className="gauto-service-area service-page-area section_70">
//         <div className="container">

//           {/* Heading */}
//           <div className="row">
//             <div className="col-md-12">
//               <div className="site-heading">
//                 <h4>Shambhu Cabs</h4>
//                 <h2>Professional & Reliable Cab Services</h2>
//               </div>
//             </div>
//           </div>

//           {/* First Row */}
//           <div className="row">

//             {/* City Transfer */}
//             <div className="col-md-4">
//               <div className="single-service">
//                 <span className="service-number">01</span>
//                 <div className="service-icon">
//                   <img src="/img/city-transport.png" alt="City Transport" />
//                 </div>
//                 <div className="service-text">
//                   <a href="#">
//                     <h3>City Transfer</h3>
//                   </a>
//                   <p>
//                     Fast, safe and comfortable rides anywhere in the city.
//                     Shambhu Cabs ensures punctual pick-ups and smooth travel for
//                     your daily commute or quick trips.
//                   </p>
//                 </div>
//               </div>
//             </div>

//             {/* Airport Transfer */}
//             <div className="col-md-4">
//               <div className="single-service">
//                 <span className="service-number">02</span>
//                 <div className="service-icon">
//                   <img src="/img/airport-transport.png" alt="Airport Transport" />
//                 </div>
//                 <div className="service-text">
//                   <a href="#">
//                     <h3>Airport Transfer</h3>
//                   </a>
//                   <p>
//                     Hassle-free airport pick-ups and drop-offs. Our drivers track
//                     your flight and ensure timely service, day or night.
//                   </p>
//                 </div>
//               </div>
//             </div>

//             {/* Hospital Transfer */}
//             <div className="col-md-4">
//               <div className="single-service">
//                 <span className="service-number">03</span>
//                 <div className="service-icon">
//                   <img src="/img/hospital-transport.png" alt="Hospital Transport" />
//                 </div>
//                 <div className="service-text">
//                   <a href="#">
//                     <h3>Hospital Transfer</h3>
//                   </a>
//                   <p>
//                     Reliable and comfortable cab assistance for hospital
//                     appointments, emergencies, or regular check-ups.
//                   </p>
//                 </div>
//               </div>
//             </div>

//           </div>

//           {/* Second Row */}
//           <div className="row">

//             {/* Wedding Ceremony */}
//             <div className="col-md-4">
//               <div className="single-service">
//                 <span className="service-number">04</span>
//                 <div className="service-icon">
//                   <img src="/img/wedding-ceremony.png" alt="Wedding Ceremony Transport" />
//                 </div>
//                 <div className="service-text">
//                   <a href="#">
//                     <h3>Wedding Ceremony Rides</h3>
//                   </a>
//                   <p>
//                     Elegant and premium cab services to make your special day even
//                     smoother. Perfect for guests and family travel.
//                   </p>
//                 </div>
//               </div>
//             </div>

//             {/* City Tour */}
//             <div className="col-md-4">
//               <div className="single-service">
//                 <span className="service-number">05</span>
//                 <div className="service-icon">
//                   <img src="/img/hotel-transport.png" alt="City Tour" />
//                 </div>
//                 <div className="service-text">
//                   <a href="#">
//                     <h3>Full City Tour</h3>
//                   </a>
//                   <p>
//                     Explore the best attractions with experienced local drivers.
//                     Comfortable rides tailored to your travel plan.
//                   </p>
//                 </div>
//               </div>
//             </div>

//             {/* Baggage Transport */}
//             <div className="col-md-4">
//               <div className="single-service">
//                 <span className="service-number">06</span>
//                 <div className="service-icon">
//                   <img src="/img/luggege-transport.png" alt="Baggage Transport" />
//                 </div>
//                 <div className="service-text">
//                   <a href="#">
//                     <h3>Baggage Transport</h3>
//                   </a>
//                   <p>
//                     Convenient luggage-only transport services for airport,
//                     railway station, or long-distance travel.
//                   </p>
//                 </div>
//               </div>
//             </div>

//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default ServiceArea;





import React from "react";
import {
  FaRoute,
  FaBriefcase,
  FaOm,
  FaClock,
  FaTrain,
  FaMapMarkedAlt
} from "react-icons/fa";

const ServiceArea = () => {
  return (
    <>
      {/* Breadcrumb */}
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3>Our Services</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="gauto-service-area service-page-area section_70">
        <div className="container">

          {/* Heading */}
          <div className="row">
            <div className="col-md-12">
              <div className="site-heading">
                <h4>Shambhu Cabs</h4>
                <h2>Professional & Reliable Cab Services</h2>
              </div>
            </div>
          </div>

          {/* ROW 1 – IMAGE SERVICES */}
          <div className="row">
            <Service
              number="01"
              img="/img/city-transport.png"
              title="City Transfer"
              desc="Fast, safe and comfortable rides anywhere in the city with punctual pick-ups."
            />
            <Service
              number="02"
              img="/img/airport-transport.png"
              title="Airport Transfer"
              desc="On-time airport pick-ups and drop-offs with flight tracking support."
            />
            <Service
              number="03"
              img="/img/hospital-transport.png"
              title="Hospital Transfer"
              desc="Reliable and comfortable assistance for hospital visits and emergencies."
            />
          </div>

          {/* ROW 2 – IMAGE SERVICES */}
          <div className="row">
            <Service
              number="04"
              img="/img/wedding-ceremony.png"
              title="Wedding Ceremony Rides"
              desc="Premium cab services for weddings, guests, and family travel."
            />
            <Service
              number="05"
              img="/img/hotel-transport.png"
              title="Full City Tour"
              desc="Explore city attractions comfortably with experienced local drivers."
            />
            <Service
              number="06"
              img="/img/luggege-transport.png"
              title="Baggage Transport"
              desc="Safe luggage transport for airport, railway station, or long trips."
            />
          </div>

          {/* ROW 3 – ICON SERVICES */}
          <div className="row">
            <ServiceIcon
              number="07"
              icon={<FaRoute />}
              title="Outstation Travel"
              desc="Comfortable and affordable outstation trips across Maharashtra and India."
            />
            <ServiceIcon
              number="08"
              icon={<FaBriefcase />}
              title="Corporate Cab Services"
              desc="Professional corporate travel solutions for offices and business clients."
            />
            <ServiceIcon
              number="09"
              icon={<FaOm />}
              title="Temple & Pilgrimage Tours"
              desc="Special cab services for temple visits and religious journeys."
            />
          </div>

          {/* ROW 4 – ICON SERVICES */}
          <div className="row">
            <ServiceIcon
              number="10"
              icon={<FaClock />}
              title="Hourly Cab Rental"
              desc="Flexible hourly rental packages for meetings, shopping, or events."
            />
            <ServiceIcon
              number="11"
              icon={<FaTrain />}
              title="Railway Station Transfer"
              desc="On-time pick-up and drop services for all major railway stations."
            />
            <ServiceIcon
              number="12"
              icon={<FaMapMarkedAlt />}
              title="All India Cab Service"
              desc="Pan-India cab services for long-distance and multi-city travel."
            />
          </div>

        </div>
      </section>
    </>
  );
};

/* IMAGE SERVICE COMPONENT */
const Service = ({ number, img, title, desc }) => (
  <div className="col-md-4">
    <div className="single-service">
      <span className="service-number">{number}</span>
      <div className="service-icon">
        <img src={img} alt={title} />
      </div>
      <div className="service-text">
        <h3>{title}</h3>
        <p>{desc}</p>
      </div>
    </div>
  </div>
);

/* ICON SERVICE COMPONENT */
const ServiceIcon = ({ number, icon, title, desc }) => (
  <div className="col-md-4">
    <div className="single-service">
      <span className="service-number">{number}</span>
      <div className="service-icon service-icon-big">
        {icon}
      </div>
      <div className="service-text">
        <h3>{title}</h3>
        <p>{desc}</p>
      </div>
    </div>
  </div>
);

export default ServiceArea;
